import React from 'react';
import Career from '../Components/Career'

const ContactUs = () => {
  return (
   
<>
<Career/>
</>
  );
};
 
export default ContactUs;